import LocationCheckboxes from './LocationCheckboxes';

export default LocationCheckboxes;
